import React, { ReactElement } from 'react';
import useStyles from './useStyles';

export type RepliconMenuFooterProps = {
  NavigationMetaData: any;
};
const RepliconMenuFooter = ({
  NavigationMetaData
}: RepliconMenuFooterProps): ReactElement => {
  const classes = useStyles();
  return (
    <div className={classes.pageFooter} style={{ padding: '8px 24px' }}>
      <span className={classes.footerDeltekRepliconLogo}></span>
      <span className="copyrightMessage">
        {NavigationMetaData?.footerMetadata?.copyrightMessage}
      </span>
      <ul className={classes.pageFooterLinks}>
        {NavigationMetaData?.footerMetadata?.links?.map((link: any) => {
          return link && link.href ? (
            <li key={link?.displayText}>
              <a href={link?.href} target={link?.target || undefined}>
                {link?.displayText}
              </a>
            </li>
          ) : null;
        })}
      </ul>
      <span className={classes.footerRepliconDeltekUserInfo}>
        {NavigationMetaData?.footerMetadata?.loggedInAsText}{' '}
        <strong>{NavigationMetaData?.footerMetadata?.loggedInAsUser}</strong>
      </span>
    </div>
  );
};
export default RepliconMenuFooter;
